import React from 'react'

export default function SharedFunc(serverId,name) {
    let path=[
        {name:'socketServerVideo',path: `https://dl${serverId}.ochatt.com/videos/`},
        {name:'socketServerMusic', path: `https://dl${serverId}.ochatt.com/musics/`},
        {name:'socketServerFile', path: `https://dl${serverId}.ochatt.com/files/`},
    ]
    let selected=path?.filter(x=>x.name==name)?.[0]?.path
  return selected
}
